export enum ChoosePropertyTypeLayoutType {
  Legacy = 'legacy',
  Modern = 'modern',
}
